import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import { Button, Col, Container, Row } from 'reactstrap';
import ToggleButton from "react-toggle-button";
import { UpdateFAQs } from '../../../stores/services/knowledgebase.service';

function EditFAQs(props) {
    const {
        refreshData,
        setRefreshData,
        setEditModalFlag
    } = props
    const [question, setQuestion] = useState<string>("")
    const [answers, setAnswers] = useState<string>("")
    const [selectedFAQsId, setSelectedFAQsId] = useState<string>("")
    const [status, setStatus] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingData, setLoadingData] = useState<boolean>(false)
    const email = sessionStorage.getItem("email") || "";
    const amc_code = sessionStorage.getItem("amc_code") || "";

    const borderRadiusStyle = { borderRadius: 2 };

    useEffect(() => {
        setLoadingData(true)
        const obj = JSON.parse(sessionStorage.getItem("FAQsObj") || "");
        setQuestion(obj?.question?.trim() || "")
        setAnswers(obj?.answer?.trim() || "")
        setSelectedFAQsId(obj?._id || "")
        setStatus(obj?.status)
        setLoadingData(false)
    }, [])

    const handleUpdate = async () => {
        if (question?.trim() == "") {
            toast.error("Question field can not be empty")
            return
        }
        if (answers?.trim() == "") {
            toast.error("Answer field can not be empty")
            return
        }
        setLoading(false)
        try {
            let res = await UpdateFAQs(
                email,
                amc_code,
                selectedFAQsId || "",
                question || "",
                answers || "",
            )
            if (res.status == 200 && res.data.status == 200) {
                toast.success(res.data.message)
                setRefreshData(!refreshData)
            }
        } catch (error) {
            toast.error("Error Updating FAQs")
        }
        finally {
            setLoading(false)
            setEditModalFlag(false)
        }
    }

    return (
        <Col md="12" className='px-0'>
            <Container fluid>
                {!loadingData ?
                    <Row>
                        <Col md="12" className='px-0'>
                            <div className="form-group">
                                <label>Question</label>
                                <input
                                    className="form-control"
                                    placeholder='Enter Question'
                                    value={question}
                                    onChange={(e) => {
                                        setQuestion(e.target.value);
                                    }}
                                />
                            </div>
                        </Col>
                        <Col md="12" className='px-0'>
                            <div className="form-group">
                                <label>Answer</label>
                                <textarea
                                    rows={3}
                                    className="form-control"
                                    placeholder='Enter Answer'
                                    value={answers}
                                    onChange={(e) => {
                                        setAnswers(e.target.value);
                                    }}
                                />
                            </div>
                        </Col>
                        {/* <Col md="12" className='px-0'>
                            <div className="form-group">
                                <label>Status</label>
                                <ToggleButton
                                    inactiveLabel=""
                                    activeLabel=""
                                    value={status}
                                    thumbStyle={borderRadiusStyle}
                                    trackStyle={borderRadiusStyle}
                                    onToggle={() => {
                                        setStatus(!status)
                                    }}
                                />
                            </div>
                        </Col> */}
                    </Row> :
                    <div className="d-flex justify-content-center my-5">
                        <div
                            className="fa fa-spinner fa-spin fa-3x mt-5 mb-5"
                            role="status"
                        >
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                }
                <Row className='d-flex justify-content-between'>
                    <Button
                        onClick={() => setEditModalFlag(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => handleUpdate()}
                        disabled={loadingData || loading}
                        color='primary'>
                        Update
                    </Button>
                </Row>
            </Container>
        </Col>
    )
}

export default EditFAQs